import {Component, inject} from '@angular/core';
import {HotToastRef} from "@ngneat/hot-toast";
import {ToastType} from "../../object/toast";
import { NgClass } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-info-toast',
    templateUrl: './info-toast.component.html',
    styleUrls: ['./info-toast.component.css'],
    imports: [NgClass]
})
export class InfoToastComponent {

  type: ToastType = ToastType.INFO;
  message: string = '';
  public toastRef: HotToastRef<any> | null = inject(HotToastRef, { optional: true });
  private readonly translateService = inject(TranslateService);

  constructor() {
    if (this.toastRef) {
      this.type = this.toastRef.data?.type ?? ToastType.INFO;
      this.message = this.toastRef.data?.message;
    }
  }

  get toneClass(): string {
    return `toast-shell--${this.type ?? ToastType.INFO}`;
  }

  get statusLabel(): string {
    return this.translateService.instant(`toast.labels.${this.type ?? ToastType.INFO}`);
  }

  get closeLabel(): string {
    return this.translateService.instant('toast.close');
  }

  get accessibilityRole(): 'status' | 'alert' {
    return this.type === ToastType.ERROR || this.type === ToastType.WARNING ? 'alert' : 'status';
  }

  get ariaLive(): 'polite' | 'assertive' {
    return this.type === ToastType.ERROR ? 'assertive' : 'polite';
  }

  closeToast(): void {
    this.toastRef?.close();
  }

  protected readonly ToastType = ToastType;
}
